import React from 'react';

import { create } from 'zustand';
import { Post } from '../http/httpVerbs';
import { ErrorModal } from '../components/error/ErrorModal';

export const useErrorStore = create((set) => ({
    error: {},
    isErrorModalOpen: false,
    showError: (message) => set({ error: message, isErrorModalOpen: true }),
    handleCloseErrorModal: () => set({ isErrorModalOpen: false }),
}));

export const ErrorProvider = ({ children }) => {
    const { error, isErrorModalOpen, handleCloseErrorModal } = useErrorStore();

    return (
        <>
            {children}
            <ErrorModal open={isErrorModalOpen} handleClose={handleCloseErrorModal} errorMessage={error} />
        </>
    );
};
